import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {PATROL_ROUTES} from '../../constants'
import {Icon} from '@therms/atalaya'
import {FaRoute} from 'react-icons/fa'

function PatrolMenuLink() {
  return (
    <MenuLink to={PATROL_ROUTES.__ROOT__}>
      <div className="gap-x-sm inline-flex items-center">
        <Icon Icon={FaRoute} size="sm" />
        <span>Patrol</span>
      </div>
    </MenuLink>
  )
}

export {PatrolMenuLink}